var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bundle)?_c('el-tag',{attrs:{"size":"mini","type":_vm.bundle.approvalStatus}},[_vm._v(_vm._s(_vm._f("trans")(_vm.bundle.approvalStatus)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }